// src/services/api-service.ts

import fetchWithToken from "../utils/fetchWithToken";
import showToast from "../utils/show.toast";

export const getRequest = async <T>(
  url: string,
  headers: Record<string, string> = {}
): Promise<T> => {
  const response = await fetchWithToken(url);

  if (!response.ok) {
    const errorData = await response.json();

    if (response.status === 403) {
      return (window.location.href = "/forbidden") as any;
    }

    throw new Error(errorData.message || "An error occured");
  }
  return response.json();
};

export const postRequest = async <T>(
  url: string,
  body: any,
  headers: Record<string, string> = { "Content-Type": "application/json" }
): Promise<T> => {
  const response = await fetchWithToken(url, {
    method: "POST",
    headers,
    body: JSON.stringify(body),
  });

  if (!response.ok) {
    const errorData = await response.json();

    if (response.status === 403) {
      return (window.location.href = "/forbidden") as any;
    }

    throw new Error(errorData.message || "An error occurred");
  }

  return response.json();
};

export const updateRequest = async <T>(
  url: string,
  body: any,
  headers: Record<string, string> = { "Content-Type": "application/json" }
): Promise<T> => {
  const response = await fetchWithToken(url, {
    method: "PATCH",
    headers,
    body: JSON.stringify(body),
  });

  if (!response.ok) {
    const errorData = await response.json();

    if (response.status === 403) {
      return (window.location.href = "/forbidden") as any;
    }

    throw new Error(errorData.message || "An error occurred");
  }

  return response.json();
};
